/**
 * Faixa acima da grade quando a sidebar recorta por cliente ou por responsável.
 *
 * Sem ela, o filtro some no meio do overlay da Agenda e o operador não tem
 * como confirmar que está vendo só a Javali — ou só o que está com ele.
 */

export function CalendarSliceBanner({
  title,
  count,
  periodPhrase,
  googleHidden,
  onClear,
}: {
  title: string;
  count: number;
  periodPhrase: string;
  googleHidden: boolean;
  onClear: () => void;
}) {
  const countLabel =
    count === 0
      ? `Nenhuma entrega ${periodPhrase}`
      : count === 1
        ? `1 entrega ${periodPhrase}`
        : `${count} entregas ${periodPhrase}`;

  return (
    <div
      role="status"
      data-testid="calendar-slice-banner"
      className="flex shrink-0 flex-wrap items-center gap-x-3 gap-y-1.5 border-b border-[var(--dream-info-border)] bg-[var(--dream-info-bg)] px-3 py-2 sm:px-4 lg:px-5"
    >
      <div className="min-w-0 flex-1">
        <p className="truncate text-[0.8125rem] font-bold text-[var(--dream-info-fg)]">{title}</p>
        <p className="text-[0.75rem] leading-5 text-[var(--color-ink-secondary)]">
          {countLabel}
          {googleHidden ? ". Compromissos da Agenda ficam de fora neste recorte." : "."}
        </p>
      </div>
      <button
        type="button"
        onClick={onClear}
        className="shrink-0 rounded-lg px-2.5 py-1 text-[0.75rem] font-semibold text-brand-600 hover:bg-[var(--color-surface)]/80 hover:underline"
      >
        Ver todos
      </button>
    </div>
  );
}
